import { z } from 'zod';

export type DocumentLocationLink = `#doc/${string}/ver/${string}/loc/${string}`;

/** The label a resolved citation gets: `[Citation](#doc/...)`. */
export const CITATION_LINK_LABEL = 'Citation';

/**
 * Creates a markdown location link in the format:
 *
 * #doc/<documentId>/ver/<versionId>/loc/<locationAnchor>
 */
export function createMarkdownLocationLink(
  documentId: string,
  versionId: string,
  locationAnchor: string
): DocumentLocationLink {
  return `#doc/${documentId}/ver/${versionId}/loc/${locationAnchor}`;
}

const locationSchema = z.tuple([
  z.literal('#doc'),
  z.string(),
  z.literal('ver'),
  z.string(),
  z.literal('loc'),
  z.string(),
]);

/**
 * Parses a markdown location link in the format:
 *
 * #doc/<documentId>/ver/<versionId>/loc/<locationAnchor>
 */
export function parseMarkdownLocationLink(
  locationString: string
): { documentId: string; locationId: string; type: 'file' | 'aline'; versionId: string } | null {
  const parts = locationString.split('/');

  const result = locationSchema.safeParse(parts);
  if (!result.success) {
    console.error('Invalid file location format:', locationString);
    return null;
  }

  const [, documentId, , versionId, , locationId] = result.data;

  const type = locationId.includes(':') ? 'file' : 'aline';

  return {
    documentId,
    locationId,
    type,
    versionId,
  };
}
